module.exports = __webpack_public_path__ + "info-new.svg?a8b3aba1ce3afdbf5ee65c1e1de06b6f";